import { useEffect, useRef } from "react";
import slide1 from "./../assets/slide_1.mp4";
import SEOLandingSection from "./SEOLandingSection";
import securityDataPrivacyImage from "./../assets/security-data-privacy-image.png";
import fashionReturnsImage from "./../assets/fashion-returns-image.png";
import returnRatesImage from "./../assets/return-rates-image.png";
import fashionCostImage from "./../assets/fashion-cost-image.png";
import provenStrategiesImage from "./../assets/proven-strategies-image.png";
import technologyRatesImage from "./../assets/technology-rates-image.png";

const ReduceFashionReturnsSections = () => {
  const videoRef = useRef(null);
  const hasPlayedRef = useRef(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!video) return;

        if (entry.isIntersecting) {
          if (!hasPlayedRef.current && video.paused && !video.ended) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(() => {});
            }
          }
        } else {
          if (!video.paused && !video.ended) {
            video.pause();
          }
        }
      },
      { threshold: 0.5 },
    );

    const handleEnded = () => {
      hasPlayedRef.current = true;
    };

    video.addEventListener("ended", handleEnded);
    observer.observe(video);

    return () => {
      video.removeEventListener("ended", handleEnded);
      observer.unobserve(video);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="font-normal text-[14px] leading-[23.4px] tracking-[0.17px] text-[#4A5565]">
      <SEOLandingSection
        heroImage={fashionReturnsImage}
        bgColor="#EAF1E9"
        heading="How to Reduce Fashion Returns in Ecommerce"
      >
        <div className="space-y-2 mt-2">
          <ul className="space-y-4">
            <li>
              Fashion e-commerce brands lose billions annually due to high
              return rates driven by sizing issues, fit uncertainty, and shopper
              indecision. If you’re looking to reduce fashion returns, lower
              operational costs, and improve margins, implementing the right
              strategy can significantly reduce fashion return rates across your
              ecommerce operations.
            </li>
            <li>
              $1 Trillion worth of fashion orders are sold online annually. $300
              Billion of these fashion orders get returned every year.
            </li>
            <li>
              How does Eveness Help? Improve size & fit accuracy using AI sizing
              software, standardize sizing data, optimize and enhance product
              descriptions, reduce bracketing behavior, implement AI-based fit
              prediction, customer profiling, and size recommendation
              algorithms.
            </li>
          </ul>
        </div>
      </SEOLandingSection>

      <SEOLandingSection
        heroImage={returnRatesImage}
        bgColor="#F3F0F5"
        heading="Why Are Fashion Ecommerce Return Rates So High?"
      >
        <div className="space-y-2 mt-2 text-[#47423D]">
          <ul className="space-y-2">
            <li>Fit technology to reduce returns</li>
            <li>Virtual Try-On Capabilities</li>
            <li>Stylist Assistance</li>
            <li>Plugs into your Product Page</li>
          </ul>
        </div>
      </SEOLandingSection>

      <SEOLandingSection
        heroImage={fashionCostImage}
        bgColor="#FEF2F1"
        heading="The True Cost of Fashion Returns"
      >
        <ul className="mt-4">
          <li>Revenue Loss</li>
          <li>Reverse Logistics Cost</li>
          <li>Inventory Depreciation</li>
          <li>Margin Erosion</li>
          <li>Environmental Impact</li>
        </ul>
      </SEOLandingSection>

      <SEOLandingSection
        heroImage={provenStrategiesImage}
        bgColor="#FCF7FF"
        heading="Proven Strategies to Reduce Fashion Returns"
      >
        <ul className="text-[#47423D] mt-[10px]">
          <li>1. Improve Size & Fit Accuracy</li>
          <li>2. Standardize Sizing Data</li>
          <li>3. Optimize Product Descriptions</li>
          <li>4. Reduce Bracketing Behavior</li>
          <li>5. Implement AI-Based Fit Prediction</li>
        </ul>
      </SEOLandingSection>

      <SEOLandingSection
        heroImage={technologyRatesImage}
        bgColor="#F7FFF7"
        heading="Technology That Helps Reduce Fashion Return Rates"
      >
        <ul className="text-[#47423D] mt-[10px]">
          <li>AI sizing software</li>
          <li>Fit prediction software</li>
          <li>Size recommendation engines</li>
          <li>Customer profiling</li>
          <li>Behavioral data modeling</li>
        </ul>
      </SEOLandingSection>

      <SEOLandingSection
        heading="Key Features of AI Apparel Sizing Software"
        showVideo={true}
        videoSrc={slide1}
        videoRef={videoRef}
        videoIndex={0}
        ctaLink="/get-started"
        ctaText="Get Started"
      >
        <div className="space-y-4">
          <ul className="text-[#47423D] mt-[10px] space-y-2">
            <li>SKU-Level Modeling</li>
            <li>API integrations</li>
            <li>Privacy compliance</li>
            <li>Real-time predictions</li>
            <li>Style-specific accuracy</li>
            <li>Real-time predictions</li>
            <li>Cross-device compatibility</li>
          </ul>
        </div>
      </SEOLandingSection>

      <div className="pb-4 md:pb-6 bg-[#DADADA] mb-[40px] md:mb-[60px]">
        <SEOLandingSection
          heroImage={securityDataPrivacyImage}
          bgColor="#EDFCFF"
          heading="Security, Data Privacy & Compliance"
          source="security"
        >
          <div className="space-y-4">
            <ul className="text-[#47423D] mt-[10px] space-y-2">
              <li>GDPR alignment</li>
              <li>SOC2 readiness</li>
              <li>Data anonymization</li>
              <li>Secure cloud storage</li>
            </ul>
          </div>
        </SEOLandingSection>
      </div>
    </div>
  );
};

export default ReduceFashionReturnsSections;
